import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  emDataService,
  emSharedModelService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';
import functions from '../functions';
import editProcessDialog from '../dialog.editProcessDialog';
import editFunctionDialog from '../functions/dialog.editFunctionDialog';
import processController from './process.controller';
import processDirective from './process.directive';


export default angular.module('app.components.advisory.enterpriseModeling.process', [
  ssDialogService,
  loaderService,
  alerts,
  actionIcon,
  emDataService,
  emSharedModelService,
  confirmDialog,
  editProcessDialog,
  editFunctionDialog,
  functions
])
  .directive('emProcess', processDirective)
  .controller('ProcessController', processController)
  .name;

console.log('app.components.advisory.enterpriseModeling.process created');
